/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InspectionDataCategoryDto } from '../../models/inspection-data-category-dto';

export interface InspectionDataControllerDeleteCategory$Params {
  id: string;
}

export function inspectionDataControllerDeleteCategory(http: HttpClient, rootUrl: string, params: InspectionDataControllerDeleteCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, inspectionDataControllerDeleteCategory.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InspectionDataCategoryDto>;
    })
  );
}

inspectionDataControllerDeleteCategory.PATH = '/api/inspection-data/category/{id}';
